<template>
    <div class="page noPadding noBackground" id="notificacion-resultados"  >
        <section class="noPadding ">
                    <div class="container ">
                        <div class="row justify-content-center ">
                            <div class="col-12 ">
                                <h4 class="titulomsn margin-30 ">
                                    {{title}}
                                </h4>
                                <p class="paragraph margin-60">
                                    {{message}}
                                </p>
                                <button class="error-cerrar margin-30">x</button>
                            </div>
                        </div>
                    </div>
        </section>
    </div>
</template>

<script>
export default {
    name:'emptyPage',
    props:['title','message']
}
</script>
<style  scoped>
#notificacion-resultados {
    padding: 0px 0 40px;
}
</style>